(function() {
  'use strict';

  const CONFIG = {
    buttonSelector: '.mxpr-fav-add',
    messages: {
      add: window.favoriteTextAdd || 'お気に入りに追加',
      added: window.favoriteTextAdded || 'お気に入りに追加済み'
    }
  };

  const API = {
    addFavorite: '/tools/prime-review/api/addFavorite',
    removeFavorite: '/tools/prime-review/api/removeFavorite'
  };

  const state = {
    favoriteVariantIds: new Set(
      (window.favoriteVariantIds || []).map(id => Number(id))
    )
  };

  function updateButton(btn, isFavorited) {
    btn.classList.toggle('is-added', isFavorited);

    const textSpan = btn.querySelector('span');
    if (textSpan) {
      textSpan.textContent = isFavorited ? CONFIG.messages.added : CONFIG.messages.add;
    }
  }

  async function callFavoriteAPI(method, productHandle, variantId, customerId) {
    const endpoint = method === 'remove' ? API.removeFavorite : API.addFavorite;

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        handle: productHandle,
        variant: variantId,
        customerId: customerId
      })
    });

    if (!response.ok) {
      throw new Error(`API call failed: ${response.status}`);
    }

    return response.json();
  }

  async function handleFavoriteClick(event) {
    event.preventDefault();

    const btn = event.currentTarget;

    if (btn.dataset.saving === 'true') return;

    const productHandle = btn.dataset.productHandle;
    const variantId = Number(btn.dataset.variantId);
    const customerId = btn.dataset.customerId;

    if (!productHandle || !variantId || !customerId) {
      console.error('Missing required data attributes');
      return;
    }

    btn.dataset.saving = 'true';
    btn.classList.add('is-saving');

    const wasFavorited = state.favoriteVariantIds.has(variantId);
    const willBeFavorited = !wasFavorited;

    try {
      updateButton(btn, willBeFavorited);

      if (wasFavorited) {
        await callFavoriteAPI('remove', productHandle, variantId, customerId);
        state.favoriteVariantIds.delete(variantId);
      } else {
        await callFavoriteAPI('add', productHandle, variantId, customerId);
        state.favoriteVariantIds.add(variantId);
      }

    } catch (error) {
      console.error('Favorite action failed:', error);
      updateButton(btn, wasFavorited);

    } finally {
      btn.classList.remove('is-saving');
      delete btn.dataset.saving;
    }
  }

  function updateButtonsByVariantId(variantId) {
    const container = document.querySelector(`.${CONFIG.containerClass}`);
    if (!container) return;

    const buttons = container.querySelectorAll(CONFIG.buttonSelector);
    buttons.forEach((btn) => {
      btn.dataset.variantId = variantId;
      const isFavorited = state.favoriteVariantIds.has(variantId);
      updateButton(btn, isFavorited);
    });
  }

  function updateButtonBySelectedVariant() {
    const variantSelector = document.querySelector('select[name="id"]');
    if (!variantSelector) return;

    const currentVariantId = Number(variantSelector.value);
    if (!currentVariantId) return;

    updateButtonsByVariantId(currentVariantId);
  }

  function initFavoriteButtons() {
    // コレクションページ・TOPページ対応：すべての .mxpr-fav-add ボタンを取得
    const buttons = document.querySelectorAll(CONFIG.buttonSelector);
    if (buttons.length === 0) return;

    buttons.forEach((btn) => {
      const variantId = Number(btn.dataset.variantId);
      const isFavorited = state.favoriteVariantIds.has(variantId);
      updateButton(btn, isFavorited);
      btn.addEventListener('click', handleFavoriteClick);
    });

    // 商品ページ用：バリアント選択時の更新
    const variantSelector = document.querySelector('select[name="id"]');
    if (variantSelector) {
      variantSelector.addEventListener('change', updateButtonBySelectedVariant);
    }
  }

  function init() {
    initFavoriteButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
